import i18n from '@/plugins/i18n';

const nginxOsGraphs = {
  lineCharts: [
    {
      width: '48%',
      title: i18n.global.t('average-accepted-connections'),
      header: {
        title: i18n.global.t('average-accepted-connections'),
        titleIcon: '',
        content: [],
        HideCenterMiscContent: true,
      },
      chartColor: ['#ff5bb6'],
      height: '12.5em',
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName: 'meter_net_connections_accepted_per_second',
      queryMetricType: 'readMetricsValues',
      childQueries: [],
      chartType: 'ApexChartLine',
      unit: '',
      axisLabels: {
        x: i18n.global.t('time'),
        y: i18n.global.t('dbm.numberOfConnections'),
      },
      labels: {
        xAxis: i18n.global.t('time'),
        yAxis: '',
      },
    },
    {
      width: '48%',
      title: i18n.global.t('active-connections'),
      header: {
        title: i18n.global.t('active-connections'),
        titleIcon: '',
        content: [],
        HideCenterMiscContent: true,
      },
      chartColor: ['#ff046e'],
      height: '12.5em',
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName: 'meter_net_connections_active',
      queryMetricType: 'readMetricsValues',
      childQueries: [],
      chartType: 'ApexChartLine',
      unit: '',
      axisLabels: {
        x: i18n.global.t('time'),
        y: i18n.global.t('dbm.numberOfConnections'),
      },
      labels: {
        xAxis: i18n.global.t('time'),
        yAxis: '',
      },
    },
    {
      width: '48%',
      title: i18n.global.t('average-dropped-connections'),
      header: {
        title: i18n.global.t('average-dropped-connections'),
        titleIcon: '',
        content: [],
        HideCenterMiscContent: true,
      },
      chartColor: ['#1be7ff'],
      height: '12.5em',
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName: 'meter_net_connections_dropped_per_second',
      queryMetricType: 'readMetricsValues',
      childQueries: [],
      chartType: 'ApexChartLine',
      unit: '',
      axisLabels: {
        x: i18n.global.t('time'),
        y: i18n.global.t('dbm.numberOfConnections'),
      },
      labels: {
        xAxis: i18n.global.t('time'),
        yAxis: '',
      },
    },
    {
      width: '48%',
      title: i18n.global.t('reading-connections'),
      header: {
        title: i18n.global.t('reading-connections'),
        titleIcon: '',
        content: [],
        HideCenterMiscContent: true,
      },
      chartColor: ['#8338ec'],
      height: '12.5em',
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName: 'meter_net_connections_reading',
      queryMetricType: 'readMetricsValues',
      childQueries: [],
      chartType: 'ApexChartLine',
      unit: '',
      axisLabels: {
        x: i18n.global.t('time'),
        y: i18n.global.t('dbm.numberOfConnections'),
      },
      labels: {
        xAxis: i18n.global.t('time'),
        yAxis: '',
      },
    },
    {
      width: '48%',
      title: i18n.global.t('waiting-connections'),
      header: {
        title: i18n.global.t('waiting-connections'),
        titleIcon: '',
        content: [],
        HideCenterMiscContent: true,
      },
      chartColor: ['#6eeb83'],
      height: '12.5em',
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName: 'meter_net_connections_waiting',
      queryMetricType: 'readMetricsValues',
      childQueries: [],
      chartType: 'ApexChartLine',
      unit: '',
      axisLabels: {
        x: i18n.global.t('time'),
        y: i18n.global.t('dbm.numberOfConnections'),
      },
      labels: {
        xAxis: i18n.global.t('time'),
        yAxis: '',
      },
    },
    {
      width: '48%',
      title: i18n.global.t('writing-connections'),
      header: {
        title: i18n.global.t('writing-connections'),
        titleIcon: '',
        content: [],
        HideCenterMiscContent: true,
      },
      chartColor: ['#e4fe1a'],
      height: '12.5em',
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName: 'meter_net_connections_writing',
      queryMetricType: 'readMetricsValues',
      childQueries: [],
      chartType: 'ApexChartLine',
      unit: '',
      axisLabels: {
        x: i18n.global.t('time'),
        y: i18n.global.t('dbm.numberOfConnections'),
      },
      labels: {
        xAxis: i18n.global.t('time'),
        yAxis: '',
      },
    },
    {
      width: '48%',
      title: i18n.global.t('average-requests'),
      header: {
        title: i18n.global.t('average-requests'),
        titleIcon: '',
        content: [],
        HideCenterMiscContent: true,
      },
      chartColor: ['#d0efc5'],
      height: '12.5em',
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName: 'meter_net_requests_per_second',
      queryMetricType: 'readMetricsValues',
      childQueries: [],
      chartType: 'ApexChartLine',
      unit: '',
      axisLabels: {
        x: i18n.global.t('time'),
        y: i18n.global.t('numberOfRequests'),
      },
      labels: {
        xAxis: i18n.global.t('time'),
        yAxis: '',
      },
    },
  ],
};
export default nginxOsGraphs;
